import React from 'react';
import { Provider } from 'react-redux';
import { store } from './src/redux/store'
import "@fontsource/nunito" // Defaults to weight 400 with all styles included.

export const wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>;
};